export class Favorite {
	id: number;
	user_id: number;
	product_id: number;
	quantity: number;
	score: number;
	description: string;
	user_name: string;
	
	created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/favorite.ts